<div>
    <div *ngIf="isNewFacility" class="row">
        <div class="col-md-8">
            <div class="form-group row">
                <label for="facilityDescription" class="col-sm-2 col-form-label font-weight-bold">Facility
                    description:<span style="color: red"> *</span></label>
                <div class="col-sm-10">
                    <div class="mb-1">(Choose Production Activity)</div>
                    <dx-select-box class="p-0" name="facilityDescription" id="facilityDescription"
                        [items]="facilityDetails" [searchEnabled]="true" displayExpr="productionActivityName"
                        valueExpr="productionActivityId" (onValueChanged)="onDescriptionValueChanged()"
                        [showClearButton]="true" [(value)]="facility.facilityDetail.productionActivityId">
                        <dx-validator>
                            <dxi-validation-rule type="required" message="Facility description is required">
                            </dxi-validation-rule>
                        </dx-validator>
                    </dx-select-box>
                </div>
            </div>
        </div>

        <div class="col-md-4 text-left mb-3 mt-4">
            <dx-button stylingMode="outlined" (click)="viewAllActivityFeedstock()" type="default"
                text="View All Activity Feedstock">
            </dx-button>
        </div>
        <dx-popup [(visible)]="feedstockVisible">
            <div *dxTemplate="let data of 'content'">
                <dx-scroll-view>
                    <activity-process-feedstock (closeEvent)="feedstockClose($event)" [closeButtonVisible]="true">
                    </activity-process-feedstock>
                </dx-scroll-view>
            </div>
        </dx-popup>
    </div>

    <div class="row">
        <div class="col-md-8">
            <div class="form-group row">
                <div class="col-sm-2">
                    <div *ngIf="!isNewFacility">
                        <label for="facilityDescriptionCombined"
                            class="col-sm-2 col-form-label font-weight-bold">Facility description:<span
                                style="color: red">*</span></label>
                    </div>
                </div>
                <div class="col-sm-10">
                    <div class="mb-1">(Prod Activity Name, Process, Feedstock, Industry, IndustrySegment, Involves
                        Gastification Using O2
                        plus solid/iquid fuel (Y/N)?)
                    </div>
                    <dx-select-box #facilityDescriptionCombined name="facilityDescriptionCombined"
                        id="facilityDescriptionCombined" [items]="facilityDetailsCombined"
                        (onValueChanged)="onDescriptionCombinedValueChanged($event)" displayExpr="combined"
                        valueExpr="activityProcessFeedstockId" [showClearButton]="true"
                        [(value)]="facility.facilityDetail.activityProcessFeedstockId">
                    </dx-select-box>
                </div>
            </div>
        </div>
    </div>



    <div *ngIf="!isNewFacility" class="row mt-1">
        <div class="md-col-12">
            <dx-data-grid id="gridContainer" [dataSource]="facility.equipments" [remoteOperations]="false"
                [showRowLines]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true"
                [allowColumnReordering]="false" [showBorders]="true" [repaintChangesOnly]="true"
                (onSelectionChanged)="equipmentSelectionChanged($event)" keyExpr="equipmentId">
                <dxo-toolbar>
                    <dxi-item>
                        <dx-button class="ap-blue-btn" (onClick)="addEquipment()" text="Add"></dx-button>
                    </dxi-item>
                    <dxi-item class="" location="after">
                        <dx-button [disabled]="!isAnyEquipmentSelected" class="ap-blue-btn" (onClick)="editEquipment()"
                            text="Edit"></dx-button>
                    </dxi-item>
                </dxo-toolbar>
                <dxo-paging [pageSize]="10"></dxo-paging>
                <dxo-editing mode="row" [allowUpdating]="false" [allowDeleting]="false" [allowAdding]="false">
                </dxo-editing>
                <dxo-selection mode="single" showCheckBoxesMode="always"></dxo-selection>
                <dxi-column type="buttons" [width]="75" fixed="true" fixedPosition="left">
                    <dxi-button name="edit"></dxi-button>
                </dxi-column>
                <dxi-column cssClass="column-group-header" caption="Equipment and Technology" alignment="center">
                    <dxi-column [allowEditing]="false" cssClass="column-header" dataField="equipmentType"
                        caption="Equipment Type"></dxi-column>
                    <dxi-column [allowEditing]="false" cssClass="column-header" dataField="customer" caption="Customer">
                    </dxi-column>
                    <dxi-column [allowEditing]="false" cssClass="column-header" dataField="technologyProvider"
                        caption="Technology Provider">
                    </dxi-column>
                </dxi-column>
            </dx-data-grid>
        </div>
    </div>

    <hr class="dashed mb-3">
    <div *ngIf="!isNewFacility && !isGeneralFacilityType" class="d-md-flex">
        <div class="flex-fill mr-2">
            <div class="form-group">
                <label>Announcement Title:</label>
                <dx-text-box [(value)]="facility.facilityDetail.announcementTitle"></dx-text-box>
            </div>
        </div>
        <div class="flex-fill mr-2">
            <label for="announcementDate">Announcement Date:</label>
            <dx-date-box id="announcementDate" [(value)]="facility.facilityDetail.announcementDate">
            </dx-date-box>
        </div>

        <div *ngIf="!isNewFacility && !isGeneralFacilityType" class="flex-fill">
            <div class="form-group">
                <label for="prospectDriver">Awarded driver:</label>

                <dx-select-box name="awardedDriver" id="awardedDriver" [items]="drivers" displayExpr="listItem"
                    valueExpr="listItem" [showClearButton]="true" [(value)]="facility.facilityDetail.awardedDriver">
                </dx-select-box>
            </div>
        </div>
    </div>

    <div class="d-md-flex">
        <div class="form-group flex-fill mr-2">
            <label for="status" class="font-weight-bold">Status:<span style="color: red"> *</span></label>
            <dx-select-box class="p-0" name="status" id="status" [items]="statuses" [searchMode]="searchModeOption"
                [searchEnabled]="true" displayExpr="statusDescription" valueExpr="statusCode"
                [(value)]="facility.facilityDetail.status">
                <dx-validator>
                    <dxi-validation-rule type="required" message="Status is required"></dxi-validation-rule>
                </dx-validator>
            </dx-select-box>
        </div>

        <div class="flex-fill mr-2">
            <div class="">
                <label for="capacity">Capacity:</label>
                <dx-number-box id="capacity" [(value)]="facility.facilityDetail.capacity"></dx-number-box>
            </div>
        </div>

        <div class="form-group mr-2">
            <label for="capacityUOM_ID">UOM:</label>
            <dx-select-box [width]="100" name="capacityUOM_ID" id="capacityUOM_ID" [items]="capacityUOMs"
                displayExpr="value" valueExpr="value" [(value)]="facility.facilityDetail.capacityUOM">
                <dx-validator>
                    <dxi-validation-rule reevaluate="true" type="custom" [validationCallback]="validateCapacity"
                        message="UOM is reqired when 'Capacity' is filled. ">
                    </dxi-validation-rule>
                </dx-validator>
            </dx-select-box>
        </div>

        <div class="form-group flex-fill mr-2">
            <label for="constructionStartupYear">Construction Startup Year:</label>
            <dx-select-box name="constructionStartupYear" id="constructionStartupYear"
                [items]="constructionStartupYears" [(value)]="facility.facilityDetail.constructionStartupYear">
            </dx-select-box>
        </div>

        <div [hidden]="isGeneralFacilityType" class="flex-fill mr-2">
            <div class="form-group">
                <label for="prospectDriver">Prospect driver:</label>

                <dx-select-box [disabled]="!isNewFacility" name="prospectDriver" id="prospectDriver" [items]="drivers"
                    displayExpr="listItem" valueExpr="listItem" [showClearButton]="true"
                    [(value)]="facility.facilityDetail.prospectDriver">
                </dx-select-box>
            </div>
        </div>
    </div>

    <div class="d-md-flex">
        <div class="form-group flex-fill mr-2">
            <label for="ShutDownYear">ShutDown Year:</label>
            <dx-date-box id="ShutDownYear" [(value)]="facility.facilityDetail.shutDownDate" displayFormat="monthAndYear"
                (onContentReady)="onDateBoxContentReady($event)">
            </dx-date-box>
        </div>

        <div class="form-group flex-fill">
            <label for="probability">Probability %</label>
            <dx-number-box id="probability" [max]="100" [min]="1" [(value)]="facility.facilityDetail.probability">
            </dx-number-box>
        </div>

        <div class="form-group flex-fill ml-2">
            <label for="onstreamDate">Actual Onstream Date:</label>
            <dx-date-box id="onstreamDate" [(value)]="facility.facilityDetail.onStreamDate" displayFormat="monthAndYear"
                (onContentReady)="onDateBoxContentReady($event)">
            </dx-date-box>
        </div>

        <div class="form-group flex-fill ml-2">
            <label for="estOnstreamDate">Estimated Onstream Date:</label>
            <dx-date-box id="estOnstreamDate" [(value)]="facility.facilityDetail.estOnstreamDate"
                displayFormat="monthAndYear" (onContentReady)="onDateBoxContentReady($event)">
            </dx-date-box>
        </div>

        <div [hidden]="!isHYCOFacilityType" class="flex-fill ml-2">
            <div class="form-group">
                <label for="smrCapital">SMR Capital:</label>
                <dx-number-box [(value)]="facility.facilityDetail.smrCapital"></dx-number-box>
            </div>
        </div>

    </div>

    <div class="d-md-flex">
        <div class="form-group mr-2">
            <label for="currency">Currency:</label>
            <dx-select-box [width]="100" name="currency" id="currency" [items]="currencies" displayExpr="value"
                valueExpr="value" [(value)]="facility.facilityDetail.currency">
            </dx-select-box>
            <dx-button class="mt-1" *ngIf="!isNewFacility" stylingMode="outlined" text="Currency Conversion"
                type="default" (onClick)="currencyConversion()">
            </dx-button>
        </div>

        <div class="form-group flex-grow-1">
            <label for="capital">{{capitalLabel}}</label>
            <dx-number-box [(value)]="facility.facilityDetail.capitalInvestment"></dx-number-box>
        </div>

        <div [hidden]="isGeneralFacilityType" class="form-group flex-fill ml-2">
            <label for="gasifierCapital">Gasifier Capital:</label>
            <dx-number-box [(value)]="facility.facilityDetail.gasifierCapital"></dx-number-box>
        </div>

        <div [hidden]="isGeneralFacilityType" class="flex-fill ml-2">
            <div class="form-group">
                <label for="asuCapital">ASU Capital:</label>
                <dx-number-box [(value)]="facility.facilityDetail.asuCapital"></dx-number-box>
            </div>
        </div>


        <div class="form-group flex-fill ml-2">
            <label for="hydrogenOtherCapital">Hydrogen/Other Capital:</label>
            <dx-number-box [(value)]="facility.facilityDetail.hydrogenOtherCapital"></dx-number-box>
        </div>

        <div *ngIf="!isNewFacility" [hidden]="!isGeneralFacilityType" class="form-group flex-fill ml-2">
            <label for="phase">Phase:</label>
            <dx-number-box id="phase" [(value)]="facility.facilityDetail.phase"></dx-number-box>
        </div>

    </div>

    <div class="form-group flex-fill ml-2">
        <label for="products">Primary Products:</label>
        <dx-radio-group valueExpr="industrialGasId" displayExpr="industrialGas" [items]="products" [(value)]="facility.facilityDetail.primaryProductId" layout="horizontal">
            <dx-validator>
                <dxi-validation-rule type="required" message="Please select primary product for this facility.">
                </dxi-validation-rule>
            </dx-validator>
        </dx-radio-group>
    </div>

    <div class="row mt-2">
        <dx-data-grid id="gridContainer" [dataSource]="facility.estimatesAndActuals" [remoteOperations]="false"
            [showRowLines]="true" [columnAutoWidth]="true" [rowAlternationEnabled]="true"
            [allowColumnReordering]="false" [showBorders]="true" (onEditCanceled)="cancelEdit($event)"
            (onSaved)="onSaved()" (onEditorPreparing)="onEditorPreparing($event)" [repaintChangesOnly]="true">
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-editing mode="row" [allowUpdating]="true" [useIcons]="true"></dxo-editing>
            <dxi-column type="buttons" [width]="75" fixed="true" fixedPosition="left">
                <dxi-button name="edit"></dxi-button>
            </dxi-column>
            <dxi-column cssClass="column-header-estimates" key caption="ESTIMATES" alignment="center">
                <dxi-column [allowEditing]="false" cssClass="column-header" dataField="industrialGas"
                    [allowEditing]="false" caption="Gas">
                </dxi-column>
                <dxi-column [visible]="false" [allowEditing]="false" cssClass="column-header"
                    dataField="industrialGasId" [allowEditing]="false" caption="Gas">
                </dxi-column>
                <dxi-column [allowEditing]="false" cssClass="column-header" dataField="industrialGasEstimate"
                    caption="Quantity"></dxi-column>
                <dxi-column [allowEditing]="false" cssClass="column-header" dataField="industrialGasEstimateUnits"
                    caption="Units">
                </dxi-column>
                <dxi-column [allowEditing]="false" cssClass="column-header" dataField="estimateSupplyFlag"
                    dataType="boolean" caption="supply">
                </dxi-column>
            </dxi-column>

            <dxi-column cssClass="column-header-green" caption="ACTUALS" alignment="center">
                <dxi-column cssClass="column-header" dataField="industrialGasQuantity" caption="Quantity">
                    <dxo-format type="fixedPoint" [precision]="4"></dxo-format>
                    <dxi-validation-rule type="required" message="Quantity is required"></dxi-validation-rule>
                </dxi-column>
                <dxi-column cssClass="column-header" dataField="uom" caption="Units" [setCellValue]="setUOMValue"
                    width="170">
                    <dxo-lookup [dataSource]="getIndustrialGasUOMs" displayExpr="longDescriptionUom" valueExpr="uom">
                    </dxo-lookup>
                    <dxi-validation-rule type="required" message="Units is required"></dxi-validation-rule>
                </dxi-column>
                <dxi-column cssClass="column-header" dataField="industrialGasPurity" caption="Purity (%)">
                    <dxi-validation-rule type="range" min="1" max="100" message="Purity (%) must be between 1 and 100">
                    </dxi-validation-rule>
                </dxi-column>
                <dxi-column cssClass="column-header" dataField="industrialGasPressure" caption="Pressure (barg)">
                    <dxi-validation-rule type="range" min="1" max="100"
                        message="Pressure (barg) must be between 1 and 100"></dxi-validation-rule>
                </dxi-column>
                <dxi-column cssClass="column-header" dataField="supplyFlag" dataType="boolean" caption="Supply?">
                </dxi-column>
                <dxi-column cssClass="column-header" dataField="opportunityAwarded" dataType="boolean"
                    caption="Supply awarded?">
                </dxi-column>
                <dxi-column cssClass="column-header" dataField="comments" caption="Comments"></dxi-column>
            </dxi-column>
        </dx-data-grid>
    </div>

    <div *ngIf="!isNewFacility && !isGeneralFacilityType" class="d-md-flex mt-2">
        <div class="form-group flex-fill mr-2">
            <label for="liquidO2TPD">Liquid O2 TPD:</label>
            <dx-number-box id="liquidO2TPD" [(value)]="facility.facilityDetail.liquidO2TPD"></dx-number-box>
        </div>

        <div class="flex-fill mr-2">
            <label for="liquidN2TPD">Liquid N2 TPD:</label>
            <dx-number-box id="capacity" [(value)]="facility.facilityDetail.liquidN2TPD"></dx-number-box>
        </div>

        <div class="flex-fill mr-2">
            <label for="liquidArgonTPD">Liquid Argon TPD:</label>
            <dx-number-box id="liquidArgonTPD" [(value)]="facility.facilityDetail.liquidArgonTPD"></dx-number-box>
        </div>

        <div class="flex-fill mr-2">
            <label for="liquidH2TPD">Liquid H2 TPD:</label>
            <dx-number-box id="liquidH2TPD" [(value)]="facility.facilityDetail.liquidH2TPD"></dx-number-box>
        </div>

        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="generateMerchantLiquid">Generate Merchant Liquid</label>
                <dx-check-box id="generateMerchantLiquid" [(value)]="facility.facilityDetail.generateMerchantLiquid">
                </dx-check-box>
            </div>

        </div>
    </div>

    <div *ngIf="isNewFacility === false && !isGeneralFacilityType" class="row">
        <div class="col-md-12">
            <div class="form-group row">
                <label for="industryServed" class="col-sm-2 col-form-label">Industry Served:</label>
                <div class="col-sm-10">
                    <div class="mb-1">(Industry - Segment - Involves Gasification Using O2 plus solid/liquid fuel
                        (Y/N)?)</div>
                    <dx-select-box class="p-0" name="industryServed" id="industryServed" [items]="businessCategories"
                        [searchMode]="searchModeOption" [searchEnabled]="true" displayExpr="name" valueExpr="id"
                        [showClearButton]="true" [(value)]="facility.facilityDetail.industryServedBusinessCategoryId">
                    </dx-select-box>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isNewFacility === false && !isGeneralFacilityType" class="row">
        <div class="col-md-12">
            <div class="form-group">
                <label>Industry Served Notes:</label>
                <dx-text-area [height]="100" [(value)]="facility.facilityDetail.industryServedNotes">
                </dx-text-area>
            </div>
        </div>
    </div>

    <div *ngIf="!isNewFacility && !isGeneralFacilityType" class="d-md-flex mt-2">
        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="repEstAwardYear">Replacement Estimated Award Year:</label>
                <dx-select-box name="repEstAwardYear" id="repEstAwardYear" [items]="repEstAwardYears"
                    [(value)]="facility.facilityDetail.repEstAwardYear">
                </dx-select-box>
            </div>
        </div>

        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="repEstProbPercentage">Replacement Estimated Probability %:</label>
                <dx-select-box name="repEstProbPercentage" id="repEstProbPercentage" [items]="estProbabilities"
                    displayExpr="name" valueExpr="value" [(value)]="facility.facilityDetail.repEstProbPercentage">
                </dx-select-box>
            </div>
        </div>

        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="repEstSupplyMode">Replacement Estimated Supply Mode:</label>
                <dx-select-box name="repEstSupplyMode" id="repEstSupplyMode" [items]="supplyModes"
                    displayExpr="listItem" valueExpr="listItem" [(value)]="facility.facilityDetail.repEstSupplyMode">
                </dx-select-box>
            </div>
        </div>

        <div *ngIf="isHYCOFacilityType === true" class="form-group flex-fill mt-4 mr-2">
            <label for="reqEstBusinessModel">Replacement Estimated Business Model:</label>
            <dx-select-box id="reqEstBusinessModel" [items]="businessModels" displayExpr="businessModelName"
                valueExpr="businessModelName" [showClearButton]="true"
                [(value)]="facility.facilityDetail.repEstBusinessModel">
            </dx-select-box>
        </div>

        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="soeToSOGConvMonthYear">SOE to SOG Conv Month/Year:</label>
                <dx-date-box id="soeToSOGConvMonthYear" [(value)]="facility.facilityDetail.soeToSOGConvMonthYear"
                    displayFormat="monthAndYear">
                </dx-date-box>
            </div>
        </div>

    </div>

    <div *ngIf="!isNewFacility && !isGeneralFacilityType" class="d-md-flex mt-2">
        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="actEstAwardYear">Acquisition Estimated Award Year:</label>
                <dx-select-box name="actEstAwardYear" id="actEstAwardYear" [items]="actEstAwardYears"
                    [(value)]="facility.facilityDetail.actEstAwardYear">
                </dx-select-box>
            </div>
        </div>

        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="actEstProbPercentage">Acquisition Estimated Probability %:</label>
                <dx-select-box name="estProbPercentage" id="actEstProbPercentage" [items]="estProbabilities"
                    displayExpr="name" valueExpr="value" [(value)]="facility.facilityDetail.actEstProbPercentage">
                </dx-select-box>
            </div>
        </div>

        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="actEstSupplyMode">Acquisition Estimated Supply Mode:</label>
                <dx-select-box name="actEstSupplyMode" id="actEstSupplyMode" [items]="supplyModes"
                    displayExpr="listItem" valueExpr="listItem" [(value)]="facility.facilityDetail.actEstSupplyMode">
                </dx-select-box>
            </div>
        </div>

        <div *ngIf="isHYCOFacilityType === true" class="form-group flex-fill mt-4 mr-2">
            <label for="acqEstBusinessModel">Acquisition Estimated Business Model:</label>
            <dx-select-box id="acqEstBusinessModel" [items]="businessModels" displayExpr="businessModelName"
                valueExpr="businessModelName" [showClearButton]="true"
                [(value)]="facility.facilityDetail.estAcquisitionBusinessModel">
            </dx-select-box>
        </div>

    </div>

    <div *ngIf="!isNewFacility" class="d-md-flex mt-2">
        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="awardedSupplyMode">Awarded Supply Mode:</label>
                <dx-select-box name="awardedSupplyMode" id="awardedSupplyMode" [items]="supplyModes"
                    displayExpr="listItem" valueExpr="listItem" [(value)]="facility.facilityDetail.awardedSupplyMode">
                </dx-select-box>
            </div>
        </div>

        <div class="form-group flex-fill mt-4 mr-2">
            <label for="awardedBusinessModel">Awarded Business Model:</label>
            <dx-select-box id="awardedBusinessModel" [items]="businessModels" displayExpr="businessModelName"
                valueExpr="businessModelName" [showClearButton]="true"
                [(value)]="facility.facilityDetail.awardedBusinessModel">
            </dx-select-box>
        </div>
    </div>

    <div *ngIf="!isNewFacility && !isGeneralFacilityType" class="d-md-flex mt-2">
        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="igcc">IGCC?</label>
                <dx-check-box id="igcc" [(value)]="facility.facilityDetail.igccFlag"></dx-check-box>
            </div>
        </div>

        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="acquisitionOpportunity">Acquisition Opportunity</label>
                <dx-check-box id="acquisitionOpportunity"
                    [(value)]="facility.facilityDetail.acquisitionOpportunityFlag"></dx-check-box>
            </div>
        </div>

        <div class="flex-fill mr-2">
            <div class="form-group text-center mt-4">
                <label class="ml-2 mr-2" for="replacementOpportunity">Replacement Opportunity</label>
                <dx-check-box id="replacementOpportunity"
                    [(value)]="facility.facilityDetail.replacementOpportunityFlag"></dx-check-box>
            </div>

        </div>
    </div>

    <hr class="dashed mb-3">

    <div class="row mt-2">
        <div class="col-md-4">
            <div class="form-group">
                <label>Syngas Molar Ratio:</label>
                <dx-number-box format="#0.00" [(value)]="facility.facilityDetail.syngasMolarRatio"></dx-number-box>
            </div>
        </div>
        <div class="col-md-8">
            <div class="form-group">
                <label>Info Source:</label>
                <dx-text-box [(value)]="facility.facilityDetail.productionFacilityInfoSource"></dx-text-box>
            </div>
        </div>
    </div>


    <div class="row">
        <div class="col-md-12">
            <div class="form-group">
                <label>Notes:</label>
                <dx-text-area [height]="100" [(value)]="facility.facilityDetail.notes">
                </dx-text-area>
            </div>
        </div>
    </div>

    <div class="row">

        <div class="col-md-7">
            <div class="form-group">
                <dx-data-grid #sourceLinkGrid [dataSource]="facility.facilityDetail.sourceLinks"
                    [remoteOperations]="false" [repaintChangesOnly]="true" [showRowLines]="true"
                    [rowAlternationEnabled]="true" [showBorders]="true" (onRowUpdating)="onUpdating($event)"
                    (onSelectionChanged)="selectionChanged($event)">
                    <dxo-editing mode="row" [refreshMode]="true" [allowUpdating]="true" [allowAdding]="true"
                        [allowDeleting]="true" [confirmDelete]="false"></dxo-editing>
                    <dxo-toolbar>
                        <dxi-item name="addRowButton" class="addrow" showText="always"> </dxi-item>
                        <dxi-item location="after">
                            <dx-button class="ap-blue-btn" (onClick)="deleteRecords()" [disabled]="!selectedItemKeys.length" icon="trash"
                                text="Delete Selected Records">
                            </dx-button>
                        </dxi-item>
                    </dxo-toolbar>
                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxi-column type="buttons" [width]="75" fixed="true" fixedPosition="left">
                        <dxi-button name="edit"></dxi-button>
                    </dxi-column>
                    <dxi-column cssClass="column-header" dataField="url" [allowEditing]="true" caption="SOURCE LINKS"
                        alignment="center" cellTemplate="cellTemplate">
                    </dxi-column>
                    <div *dxTemplate="let data of 'cellTemplate'">
                        <a [href]="'//' + data.value" target="_blank">{{data.value}}</a>
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <div class="col-md-5">
            <div class="form-group">
                <div class="row">
                    <div class="col-4">
                        <div class="form-group">
                            <label>Attachment File Type:</label>
                            <dx-select-box name="fileType" id="fileType" [items]="fileTypes" displayExpr="value"
                                valueExpr="value" [(value)]="fileType"></dx-select-box>
                        </div>
                    </div>
                    <div class="col-8 mt-2">
                        <dx-file-uploader name="attachments" labelText=""
                            [(value)]="facility.facilityDetail.attachments" [multiple]="true"
                            (onValueChanged)="readFiles($event)" uploadMode="useForm" [maxFileSize]="4000000"
                            selectButtonText="Attach Files">
                        </dx-file-uploader>
                        <div class="ml-2"
                            *ngFor="let existingAttachment of facility.facilityDetail.existingAttachments; let i = index">
                            <a href="" (click)="download(existingAttachment.fileName)">
                                {{ existingAttachment.fileName }}
                            </a>
                            <label>&nbsp;&nbsp;&nbsp;File Type: {{ existingAttachment.fileTypeDescription }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <business-potential #BusinessPotentialComponent [isNewFacility]="isNewFacility" [facility]="facility"
        [businessModels]="businessModels" [facilityType]="facility.facilityType"></business-potential>
</div>
<currency-conversion (closeEvent)="closePopupWindow($event)"
    [currencyConversionPopupVisible]="currencyConversionPopupVisible" [facility]="facility"></currency-conversion>